import { PageContent } from '@app/components/page/PageContent';
import { PageHeaderSkeleton } from '@app/components/page/header/skeleton/PageHeaderSkeleton';
import { Box, Grid, Skeleton } from '@mui/material';

/**
 * Loading placeholder for the social export upload screen.
 * Mirrors Page.Header (one breadcrumb + title row), Page.Content maxWidth, and the form / preview grid.
 */
export function SocialExportUploadPageSkeleton() {
  return (
    <>
      <PageHeaderSkeleton breadcrumbs={1} />
      <PageContent maxWidth="lg">
        <Box sx={{ mb: 2 }}>
          <Skeleton variant="rounded" width="100%" height={60} />
        </Box>
        <Grid container spacing={4}>
          <Grid item xs={12} md={7}>
            <Skeleton variant="rounded" width="72%" height={20} sx={{ mb: 2 }} />
            <Skeleton variant="rounded" width="100%" height={40} sx={{ mb: 2 }} />
            <Skeleton variant="rounded" width="100%" height={40} sx={{ mb: 2 }} />
            <Skeleton variant="rounded" width="88%" height={40} sx={{ mb: 2 }} />
            <Skeleton variant="rounded" width="100%" height={80} sx={{ mb: 2 }} />
            <Skeleton variant="rounded" width="72%" height={20} sx={{ mb: 2 }} />
            <Skeleton variant="rounded" width="88%" height={40} sx={{ mb: 2 }} />
            <Skeleton variant="rounded" width="100%" height={80} sx={{ mb: 2 }} />
            <Box display="flex" justifyContent="flex-end" gap={1} mt={2}>
              <Skeleton variant="rounded" width={88} height={36} />
              <Skeleton variant="rounded" width={120} height={36} />
            </Box>
          </Grid>
          <Grid item xs={12} md={5}>
            <Skeleton variant="rounded" width="100%" height="300px" />
          </Grid>
        </Grid>
      </PageContent>
    </>
  );
}
